import Config from '@/classes/Config';
import app from './app';

export default new Config({
  app,
});
